export default "__VITE_ASSET__d1eee80a__"